<mat-form-field class="mat-field-width">
    <mat-select [formControl]="control"
                [placeholder]="config.label"
                [errorStateMatcher]="errorMatcher">
        <mat-option *ngFor="let tag of trackingList" [value]="tag.key">
            {{tag.value}}
        </mat-option>
    </mat-select>
    <mat-error>
        <span>Required</span>
    </mat-error>
</mat-form-field>